var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"stickprov-create-modal"}},[_c('ErrorPopup',{attrs:{"error":_vm.error}}),_c('memlist-modal',{ref:"stickprov-modal",attrs:{"size":"xl"}},[_c('StickprovWizard',{on:{"stickprovCreated":_vm.created}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }